import React from "react";

/**
 * 5-color brand stripe — visible signature of the DW brand board.
 * Used as a subtle ribbon below the navbar and inside hero/footer areas.
 */
export const BrandStripe = ({ thickness = "h-1", className = "" }) => (
  <div
    aria-hidden="true"
    className={`flex w-full ${thickness} ${className}`}
    data-testid="brand-stripe"
  >
    <span className="flex-1 bg-black" />
    <span className="flex-1 bg-[#00A651]" />
    <span className="flex-1 bg-[#E88C2F]" />
    <span className="flex-1 bg-[#ED1C24]" />
    <span className="flex-1 bg-[#F26522]" />
  </div>
);

export default BrandStripe;
